import i18next from 'i18next';

export const uploadArquivo = {
    templateArquivo: function (titulo, arquivo, id, btnRemover) {
        "use strict";
        var html = [
            '<div class="box-anexo">',
            '<p><i class="fa fa-paperclip"></i> ' + titulo + '</p>',
            '<ul class="list-inline">',
            '<li><a href="/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DownloadArquivo?arquivo=' + arquivo + '&nome=' + titulo + '" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i> ' + i18next.t('uploadDownload') + '</a></li>',
            '<li><a href="javascript:void(0);" class="btn-editar-upload" data-id="' + id + '" data-titulo="' + titulo + '"><i class="fa fa-edit" aria-hidden="true"></i> ' + i18next.t('uploadEditar') + '</a></li>',
            (btnRemover ? '<li><a href="javascript:void(0);" class="text-danger btn-remover" data-id="' + id + '"><i class="fa fa-times" aria-hidden="true"></i> ' + i18next.t('uploadRemover') + '</a></li>' : ''),
            '</ul>',
            '</div>'];

        $('#' + id).val(arquivo);

        var $box = $('#box-' + id);

        $box.find('.carregar').html(html.join(''));
        $box.find('.btn').hide();

        $box.find('.btn-editar-upload').on('click', function () {
            var $this = $(this);
            uploadArquivo.abrir($this.attr('data-id'), $this.attr('data-titulo'));
        });
        if (btnRemover) {
            $box.find('.btn-remover').on('click', function () {
                var inputID = $(this).attr('data-id');
                uploadArquivo.remover(inputID);
            });
        }

    },
    abrir: function (id, titulo) {
        "use strict";
        var $modalUpload = $('#modal-upload');
        $modalUpload.find('#elementUpload').val(id);
        $modalUpload.find('#elementTexto').val(titulo);

        $modalUpload.find('#start-upload').hide();
        $modalUpload.find('#init-upload').show();

        $modalUpload.find('.progress-bar').css('width', '0%');

        $modalUpload.modal();
    },
    remover: function (inputID) {
        window.global.loaderFull.show();
        //verificar se pode remover
        $('#' + inputID).val('');
        var $boxRemove = $('#box-' + inputID);
        $boxRemove.find('.carregar').html('');
        $boxRemove.find('.btn').show();
        toastr.success(i18next.t('uploadRemoverMsg'), '', { "closeButton": true });
        window.global.loaderFull.hide();

    },
    init: function () {
        "use strict";
        var $modalUpload = $('#modal-upload');

        var $formUpload = $modalUpload.find('#fileupload');
        $formUpload.fileupload({
            dataType: 'json',
            progressall: function (e, data) {
                var progress = parseInt(data.loaded / data.total * 100, 10);
                $formUpload.find('.progress-bar').css('width', progress + '%');
                $formUpload.find('#loader-progresso-upload').html(progress + '%');
                if (progress == 100) {
                    window.global.loaderFull.show();
                }

            },
            add: function (e, data) {
                $formUpload.find('#init-upload').hide();
                $formUpload.find('#start-upload').show();

                if (data.files.length > 0) {
                    const fileSize = data.files[0].size;
                    const fileMb = fileSize / 1024 ** 2;
                    const tamanhoMaximoMb = 5;

                    if (fileMb >= tamanhoMaximoMb) {
                        toastr.error(i18next.t('validacaoUploadArquivo') + " " + tamanhoMaximoMb + 'mb', '', { "closeButton": true });
                        window.global.loaderFull.hide();
                    }
                    else
                        data.submit();
                }
            },
            done: function (e, data) {
                window.global.loaderFull.hide();
                if (data.result.sucesso) {

                    var elementUpload = $formUpload.find('#elementUpload').val();
                    var texto = $formUpload.find('#elementTexto').val();

                    uploadArquivo.templateArquivo(texto, data.result.arquivo, elementUpload, false);
                    $modalUpload.modal('hide');

                    toastr.success(data.result.mensagem, '', { "closeButton": true });
                } else {
                    $formUpload.find('#init-upload').show();
                    $formUpload.find('#start-upload').hide();
                    $formUpload.find('.progress-bar').css('width', '0%');
                    toastr.error(data.result.mensagem, '', { "closeButton": true });
                }

            },
            fail: function (e, data) {
                toastr.error(i18next.t('uploadErro'), '', { "closeButton": true });
            }
        });
    }
};

export const uploadLaudo = {
    htmlArquivo: function (model) {
        "use strict";
        var html = [
            '<div class="laudo-anexo">',
            '<div class="col-md-6 box-anexo">',
            '<p class="mb0"><i class="fa fa-paperclip"></i> <b>' + i18next.t('laudoNome') + '</b><small> - ' + model.DataCadastro + '</small></p>',
            '<ul class="list-inline">',
            '<li><a href="/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DownloadArquivo?arquivo=' + model.Arquivo + '&nome=Laudo" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i> ' + i18next.t('uploadDownload') + '</a></li>',
            '<li><a href="javascript:void(0);" class="text-danger btn-remover" data-id="' + model.ID + '"><i class="fa fa-times" aria-hidden="true"></i> ' + i18next.t('uploadRemover') + '</a></li>',
            '</ul>',
            '</div>',
            '</div>'];

        return html.join('');
    },
    templateArquivo: function (model) {
        "use strict";
        var html = uploadLaudo.htmlArquivo(model);

        var $box = $('.lista-laudo');

        $box.append(html);


        $box.find('.btn-remover').off('click').on('click', function () {
            var id = $(this).attr('data-id');
            uploadLaudo.excluirArquivo(id, $(this).parents('.laudo-anexo'));



        });


    },
    excluirArquivo: function (id, $container) {
        swal({
            title: i18next.t('laudoExcluirTitle'),
            html: i18next.t('laudoExcluirDescricao'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('laudoExcluirSim'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function (isConfirm) {
            if (isConfirm) {
                window.global.loaderFull.show();
                $.ajax({
                    type: "POST",
                    url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteDeficienciaLaudo',
                    data: { id: id },
                    success: function (dados) {
                        window.global.loaderFull.hide();
                        if (dados.sucesso) {
                            $container.remove();
                            toastr.success(i18next.t('laudoExcluirSucesso'), '', { "closeButton": true });

                        } else {
                            toastr.error(dados.mensagem, '', { "closeButton": true });
                        }
                    },
                    error: function () {
                        window.global.loaderFull.hide();
                        toastr.error(i18next.t('laudoExcluirErro'), '', { "closeButton": true });
                    }
                });

            }
        });


    },
    abrir: function () {
        "use strict";
        var $modalUpload = $('#modal-upload-laudo');

        $modalUpload.find('#start-upload').hide();
        $modalUpload.find('#init-upload').show();

        $modalUpload.find('.progress-bar').css('width', '0%');

        $modalUpload.modal();
    },
    init: function () {
        "use strict";
        var $modalUpload = $('#modal-upload-laudo');

        var $formUpload = $modalUpload.find('#fileuploadLaudo');
        $formUpload.fileupload({
            dataType: 'json',
            progressall: function (e, data) {
                var progress = parseInt(data.loaded / data.total * 100, 10);
                $formUpload.find('.progress-bar').css('width', progress + '%');
                $formUpload.find('#loader-progresso-upload').html(progress + '%');
                if (progress == 100) {
                    window.global.loaderFull.show();
                }

            },
            add: function (e, data) {
                $formUpload.find('#init-upload').hide();
                $formUpload.find('#start-upload').show();

                if (data.files.length > 0) {
                    const fileSize = data.files[0].size;
                    const fileMb = fileSize / 1024 ** 2;
                    const tamanhoMaximoMb = 5;

                    if (fileMb >= tamanhoMaximoMb) {
                        toastr.error(i18next.t('validacaoUploadArquivo') + " " + tamanhoMaximoMb + 'mb', '', { "closeButton": true });
                        $formUpload.find('#init-upload').show();
                        $formUpload.find('#start-upload').hide();
                        $formUpload.find('.progress-bar').css('width', '0%');
                    }
                    else
                        data.submit();
                }
            },
            done: function (e, data) {
                window.global.loaderFull.hide();
                if (data.result.sucesso) {

                    uploadLaudo.templateArquivo(data.result.model);
                    $modalUpload.modal('hide');

                    toastr.success(data.result.mensagem, '', { "closeButton": true });
                } else {
                    $formUpload.find('#init-upload').show();
                    $formUpload.find('#start-upload').hide();
                    $formUpload.find('.progress-bar').css('width', '0%');
                    toastr.error(data.result.mensagem, '', { "closeButton": true });
                }

            },
            fail: function (e, data) {
                toastr.error(i18next.t('uploadErro'), '', { "closeButton": true });
            }
        });
    }
};

export const uploadCurriculo = {
    // Espelha extensoesPermitidas de CurriculoParserBusiness.PrepararUploadCurriculo. O accept do input
    // ja filtra o seletor, mas arquivo solto por drag & drop chega sem passar por ele.
    extensoesPermitidas: ['.pdf', '.docx', '.jpg', '.jpeg', '.png', '.bmp'],
    sanitizarNomeArquivo: function (nomeArquivo) {
        if (!nomeArquivo) return "";
        const nomeSanitizado = nomeArquivo.replace(/[^a-zA-Z0-9._-]/g, '');
        return nomeSanitizado;
    },
    // O modal de progresso e montado em JS com estilo inline e nao alcanca os tokens do Sass; a cor sai
    // da custom property --cv-acento (curriculo.scss), que ja resolve o tema do hotsite. O literal e so
    // rede de seguranca se a folha nao tiver carregado — mesmo valor de $primary-pure.
    _corAcento: function () {
        var cor = getComputedStyle(document.documentElement).getPropertyValue('--cv-acento');
        return (cor || '').trim() || '#1B1B63';
    },
    _corSucesso: function () {
        var cor = getComputedStyle(document.documentElement).getPropertyValue('--cv-sucesso');
        return (cor || '').trim() || '#205A24';
    },
    _cvStepIdx: 0,
    _abrirSwalProgresso: function () {
        var steps = [i18next.t('uploadCVParserStep1'),i18next.t('uploadCVParserStep2'),i18next.t('uploadCVParserStep3'),i18next.t('uploadCVParserStep4'),i18next.t('uploadCVParserStep5'),i18next.t('uploadCVParserStep6'),i18next.t('uploadCVParserStep7')] || ['Enviando currículo...'];
        var acento = uploadCurriculo._corAcento();
        uploadCurriculo._cvStepIdx = 0;

        var html = '<div style="text-align:center;padding:15px 0 10px">' +
            '<div style="margin-bottom:20px">' +
                '<svg width="70" height="70" viewBox="0 0 70 70">' +
                    '<circle cx="35" cy="35" r="30" fill="none" stroke="#e8e8e8" stroke-width="5"/>' +
                    '<circle cx="35" cy="35" r="30" fill="none" stroke="' + acento + '" stroke-width="5" stroke-dasharray="188" stroke-dashoffset="188" stroke-linecap="round">' +
                        '<animateTransform attributeName="transform" type="rotate" from="0 35 35" to="360 35 35" dur="1.1s" repeatCount="indefinite"/>' +
                        '<animate attributeName="stroke-dashoffset" values="188;47;188" dur="1.4s" repeatCount="indefinite"/>' +
                    '</circle>' +
                '</svg>' +
            '</div>' +
            '<div id="cv-step-text" style="font-size:15px;font-weight:600;color:#333;min-height:22px;transition:opacity 0.3s ease">' + steps[0] + '</div>' +
            '<div style="margin:16px auto 0;max-width:300px;height:6px;background:#e9ecef;border-radius:3px;overflow:hidden">' +
                '<div id="cv-progress-bar" style="height:100%;width:5%;background:' + acento + ';border-radius:3px;transition:width 0.8s ease"></div>' +
            '</div>' +
            '<div id="cv-timer" style="font-size:12px;color:#aaa;margin-top:10px">0s</div>' +
            '<div style="margin-top:16px;padding:10px 15px;background:#F2F5FB;border-radius:6px;font-size:12px;color:#666;line-height:1.5">' +
                '<span style="color:' + acento + ';font-weight:600">' + (i18next.t('uploadCVParserDicaLabel') || 'Dica:') + '</span> ' +
                (i18next.t('uploadCVParserDica') || '') +
            '</div>' +
        '</div>';

        swal({
            title: i18next.t('uploadCVAnalisandoTitle') || 'Analisando seu currículo',
            html: html,
            showConfirmButton: false,
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false
        });
    },
    init: function () {
        var $containerAnexar = $('#row-anexar-curriculo');
        var $formUpload = $containerAnexar.find('#form-anexar-curriculo');
        var $dropzone = $containerAnexar.find('#cv-dropzone');

        $('.btn-preencher-manualmente').on('click', function () {
            $('#row-anexar-curriculo').fadeOut('slow');
        });

        // Estado "ja anexado": reenviar dispara o mesmo fluxo do input escondido. Nao e destrutivo —
        // o job do parser pula as secoes que ja estao preenchidas (CurriculoParserBusiness.add*).
        $('#btn-substituir-curriculo').on('click', function (e) {
            e.preventDefault();
            $('#fileInputUploadCurriculo').trigger('click');
        });

        // Realce enquanto o arquivo esta sobre a area. dragleave tambem dispara ao passar por elementos
        // filhos, por isso o contador: so tira o realce quando de fato saiu da dropzone.
        var profundidadeArraste = 0;
        $dropzone.on('dragenter dragover', function (e) {
            e.preventDefault();
            if (e.type === 'dragenter') profundidadeArraste++;
            $dropzone.addClass('is-dragover');
        }).on('dragleave drop', function (e) {
            if (e.type === 'drop') profundidadeArraste = 0;
            else profundidadeArraste--;

            if (profundidadeArraste <= 0) {
                profundidadeArraste = 0;
                $dropzone.removeClass('is-dragover');
            }
        });

        $formUpload.fileupload({
            dataType: 'json',
            // Sem isto o dropZone default do plugin e $(document): soltar um arquivo em QUALQUER ponto da
            // pagina disparava o upload do curriculo.
            dropZone: $dropzone,
            progressall: function (e, data) {
                var progress = parseInt(data.loaded / data.total * 100, 10);
            },
            add: function (e, data) {
                if (!data.files || data.files.length === 0) {
                    return;
                }

                const arquivoOriginal = data.files[0];
                const nomeOriginal = arquivoOriginal.name;
                const nomeSanitizado = uploadCurriculo.sanitizarNomeArquivo(nomeOriginal);

                if (nomeOriginal !== nomeSanitizado) {
                    const arquivoCopia = new File([arquivoOriginal], nomeSanitizado, {
                        type: arquivoOriginal.type,
                        lastModified: arquivoOriginal.lastModified,
                    });
                    data.files[0] = arquivoCopia;
                }

                const nomeParaExtensao = (nomeOriginal || '').toLowerCase();
                const extensao = nomeParaExtensao.slice(nomeParaExtensao.lastIndexOf('.'));

                if (nomeParaExtensao.indexOf('.') === -1 || uploadCurriculo.extensoesPermitidas.indexOf(extensao) === -1) {
                    toastr.error($formUpload.attr('data-msg-formato'), '', { "closeButton": true });
                    return;
                }

                const fileSize = data.files[0].size;
                const fileMb = fileSize / 1024 ** 2;
                const tamanhoMaximoMb = 10;

                if (fileMb >= tamanhoMaximoMb) {
                    toastr.error(i18next.t('validacaoUploadArquivo') + " " + tamanhoMaximoMb + 'mb', '', { "closeButton": true });
                }
                else {
                    // Abre o swal de progresso completo imediatamente (mesmo visual do polling)
                    uploadCurriculo._abrirSwalProgresso();
                    data.submit();
                }
            },
            done: function (e, data) {

                if (data.result.sucesso) {
                    if (data.result.processando) {
                        // O swal já está aberto desde o add — apenas iniciar timers e polling
                        var _cvSteps = [i18next.t('uploadCVParserStep1'),i18next.t('uploadCVParserStep2'),i18next.t('uploadCVParserStep3'),i18next.t('uploadCVParserStep4'),i18next.t('uploadCVParserStep5'),i18next.t('uploadCVParserStep6'),i18next.t('uploadCVParserStep7')] || [];
                        var _cvSeconds = 0;

                        // Rotaciona as etapas visuais a cada 4s com fade
                        var _cvStepTimer = setInterval(function () {
                            uploadCurriculo._cvStepIdx++;
                            if (uploadCurriculo._cvStepIdx >= _cvSteps.length) uploadCurriculo._cvStepIdx = 0;

                            var el = document.getElementById('cv-step-text');
                            if (el) {
                                el.style.opacity = '0';
                                setTimeout(function () {
                                    el.textContent = _cvSteps[uploadCurriculo._cvStepIdx];
                                    el.style.opacity = '1';
                                }, 300);
                            }

                            var bar = document.getElementById('cv-progress-bar');
                            if (bar) {
                                var pct = Math.min(5 + (uploadCurriculo._cvStepIdx + 1) * 13, 92);
                                bar.style.width = pct + '%';
                            }
                        }, 4000);

                        // Contador de tempo (segundos / minutos)
                        var _cvSecTimer = setInterval(function () {
                            _cvSeconds++;
                            var tm = document.getElementById('cv-timer');
                            if (tm) {
                                if (_cvSeconds < 60) {
                                    tm.textContent = _cvSeconds + 's';
                                } else {
                                    var min = Math.floor(_cvSeconds / 60);
                                    var sec = _cvSeconds % 60;
                                    tm.textContent = min + 'min ' + (sec < 10 ? '0' : '') + sec + 's';
                                }
                            }
                        }, 1000);

                        // Polling real a cada 3s
                        var pollingCount = 0;
                        var maxPolling = 60; // 60 * 3s = 3 min
                        var pollingTimer = setInterval(function () {
                            pollingCount++;

                            if (pollingCount >= maxPolling) {
                                clearInterval(pollingTimer);
                                clearInterval(_cvStepTimer);
                                clearInterval(_cvSecTimer);
                                swal({
                                    title: i18next.t('uploadCVSucessoTitle'),
                                    html: '<div style="padding:10px 0"><p style="font-size:15px;color:#555;margin:0;margin-bottom:20px">' + i18next.t('uploadCVParserTimeout') + '</p></div>',
                                    type: "info",
                                    showCancelButton: false,
                                    confirmButtonColor: uploadCurriculo._corAcento(),
                                    confirmButtonText: "OK",
                                    closeOnConfirm: false,
                                    allowOutsideClick: false
                                }, function () {
                                    window.location.href = '/' + CULTURE_EMPREGARE + '/candidato/curriculo?hideParser=1';
                                });
                                return;
                            }

                            $.get('/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/StatusUploadCurriculo', function (result) {
                                if (result.status === 'concluido') {
                                    clearInterval(pollingTimer);
                                    clearInterval(_cvStepTimer);
                                    clearInterval(_cvSecTimer);

                                    // Animação de conclusão: barra 100% + checkmark
                                    var corSucesso = uploadCurriculo._corSucesso();
                                    var bar = document.getElementById('cv-progress-bar');
                                    if (bar) { bar.style.width = '100%'; bar.style.background = '#27ae60'; }
                                    var step = document.getElementById('cv-step-text');
                                    // Verde escuro no TEXTO (o #27ae60 da barra reprova contraste WCAG como texto).
                                    if (step) { step.style.color = corSucesso; step.textContent = i18next.t('uploadCVParserConcluido'); }

                                    setTimeout(function () {
                                        var _successHtml = '<div style="text-align:center;padding:15px 0 5px">' +
                                            '<div style="margin-bottom:15px">' +
                                                '<svg width="64" height="64" viewBox="0 0 64 64">' +
                                                    '<circle cx="32" cy="32" r="30" fill="#27ae60"/>' +
                                                    '<path d="M20 33 L28 41 L44 24" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>' +
                                                '</svg>' +
                                            '</div>' +
                                            '<p style="font-size:15px;color:#555;margin:0;margin-bottom:20px">' + i18next.t('uploadCVSucessoDescricao') + '</p>' +
                                        '</div>';

                                        swal({
                                            title: i18next.t('uploadCVSucessoTitle'),
                                            html: _successHtml,
                                            showCancelButton: false,
                                            confirmButtonColor: uploadCurriculo._corAcento(),
                                            confirmButtonText: i18next.t('uploadCVRevisar'),
                                            closeOnConfirm: false,
                                            allowOutsideClick: false
                                        }, function (isConfirm) {
                                            if (isConfirm) {
                                                window.location.href = '/' + CULTURE_EMPREGARE + '/candidato/curriculo?hideParser=1';
                                            }
                                        });
                                    }, 900);
                                } else if (result.status === 'erro') {
                                    clearInterval(pollingTimer);
                                    clearInterval(_cvStepTimer);
                                    clearInterval(_cvSecTimer);
                                    swal.closeModal();
                                    toastr.error(result.mensagem || i18next.t('uploadErro'), '', { "closeButton": true });
                                }
                            }).fail(function () {
                                // Falha na requisição de polling - continua tentando
                            });
                        }, 3000);
                    } else {
                        // Fluxo legado (síncrono)
                        swal({
                            title: i18next.t('uploadCVSucessoTitle'),
                            html: i18next.t('uploadCVSucessoDescricao'),
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: uploadCurriculo._corAcento(),
                            confirmButtonText: i18next.t('uploadCVRevisar'),
                            closeOnConfirm: false,
                            allowOutsideClick: false
                        }, function (isConfirm) {
                            if (isConfirm) {
                                window.location.href = '/' + CULTURE_EMPREGARE + '/candidato/curriculo?hideParser=1';
                            }
                        });
                    }
                } else {
                    swal.closeModal();
                    toastr.error(data.result.mensagem, '', { "closeButton": true });
                }
            },
            fail: function (e, data) {
                swal.closeModal();
                window.global.loaderFull.hide();
                toastr.error(i18next.t('uploadErro'), '', { "closeButton": true });
            }
        });
    }
};

